import { useGetCouponsByUser } from '@xhype/card-app-sdk';
import { useGetUserData } from '@package/smart-wallet/hooks';

export const useGetUserCoupons = () => {
  const { userInfo } = useGetUserData();
  const userId = userInfo?.id;

  const response = useGetCouponsByUser({ userId: userId!, enabled: true });

  return {
    coupons: response.data?.records || [],
  };
};
